import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormID } from '@finxone-platform/form-action';
import { BeneficiaryRequirementsResponse } from '@finxone-platform/shared/sys-config-types';
import { Observable, of } from 'rxjs';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';

@Injectable()
export class MockBeneficiaryFormService {
  private readonly FORM_KEY = FormID.BENEFICIARY_FORM;

  constructor(private workflowFormsService: WorkflowFormsService) {
    // The form is initialised in MockWorkflowFormsService
    this.workflowFormsService.registerCurrentPageFormWidgetForm(this.FORM_KEY);
  }

  public get beneficiaryForm(): FormGroup {
    return this.workflowFormsService.getFormPart(this.FORM_KEY) as FormGroup;
  }

  public getValidationConfig(_validation: any): { type: string; message: string }[] {
    // Return mock validation config
    return [{ type: 'required', message: 'This field is required' }];
  }

  public getAndSetBeneficiaryRequirements(): Observable<BeneficiaryRequirementsResponse> {
    // Return a mock response
    return of({
      beneficiaryBankAccount: {
        iban: { requirement: 'required', regex: '^\\w+$' },
        accountNumber: { requirement: 'required', regex: '^\\d+$' },
        bankName: { requirement: 'optional' },
        routingCodes: {},
        requirements: {},
      },
      beneficiaryAddress: {
        addressLine1: { requirement: 'required' },
        city: { requirement: 'required' },
        postalCode: { requirement: 'required' },
        country: { requirement: 'required' },
      },
    } as BeneficiaryRequirementsResponse);
  }
}
